import { render } from "./BarcodePairingDialog.vue?vue&type=template&id=f9937e6c&scoped=true"
import script from "./BarcodePairingDialog.vue?vue&type=script&lang=ts"
export * from "./BarcodePairingDialog.vue?vue&type=script&lang=ts"

import "./BarcodePairingDialog.vue?vue&type=style&index=0&id=f9937e6c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f9937e6c"

export default script